__turbopack_context__.v({
  "fluid": "Input-module__F2qWWG__fluid",
  "icon": "Input-module__F2qWWG__icon",
  "iconInput": "Input-module__F2qWWG__iconInput",
  "input": "Input-module__F2qWWG__input",
  "inputField": "Input-module__F2qWWG__inputField",
});
